<button #button
        type="button"
        class="btn"
        [ngClass]="getClass()"
        (click)="onClick()"
        (focus)="onButtonFocus()"
        [disabled]="disabled || waiting">
    <waiting-spinner *ngIf="waiting" [size]="15" color="#1d3f50"></waiting-spinner>
    <ng-content></ng-content>
</button>